import { CommonModule } from '@angular/common';
import { Component, HostListener, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { NotificationsService } from '../../service/notifications.service';
import { IconComponent } from '../icon/icon.component';

// Navigazione mobile in stile app: bottom tab bar fissa, visibile solo <768px (vedi CSS).
// Home/Calendario/Crea evento sono routerLink; Notifiche e Altro aprono pannelli a comparsa
// che riusano rispettivamente NotificationsService (condiviso con la campanella desktop)
// e i link della navbar oggi non presenti come scorciatoia rapida.
@Component({
  selector: 'app-bottom-tab-bar',
  templateUrl: './bottom-tab-bar.component.html',
  styleUrl: './bottom-tab-bar.component.css',
  imports: [CommonModule, RouterLink, RouterLinkActive, TranslatePipe, IconComponent],
})
export class BottomTabBarComponent {
  private router = inject(Router);
  notif = inject(NotificationsService);

  notifOpen = false;
  moreOpen = false;

  moreLinks = [
    { path: '/eventi', icon: 'rings', labelKey: 'navbar.wedding' },
    { path: '/contratti', icon: 'file', labelKey: 'navbar.contracts' },
    { path: '/listino', icon: 'euro', labelKey: 'navbar.pricelist' },
    { path: '/statistiche', icon: 'chart', labelKey: 'navbar.statistics' },
    { path: '/collaborazioni', icon: 'handshake', labelKey: 'navbar.collaborations' },
    { path: '/impostazioni', icon: 'settings', labelKey: 'navbar.settings' },
  ];

  toggleNotif(): void {
    this.moreOpen = false;
    this.notifOpen = !this.notifOpen;
    if (this.notifOpen) this.notif.ensureLoaded();
  }

  toggleMore(): void {
    this.notifOpen = false;
    this.moreOpen = !this.moreOpen;
  }

  closePanels(): void {
    this.notifOpen = false;
    this.moreOpen = false;
  }

  markRead(n: any): void {
    this.notif.markRead(n, (notif) => {
      this.notifOpen = false;
      this.notif.navigateToNotif(notif);
    });
  }

  markAllRead(): void {
    this.notif.markAllRead();
  }

  getNotifIcon(type: string): string {
    return this.notif.getNotifIcon(type);
  }

  goMore(path: string): void {
    this.moreOpen = false;
    this.router.navigate([path]);
  }

  @HostListener('document:click', ['$event'])
  onDocClick(e: MouseEvent): void {
    const target = e.target as HTMLElement;
    if (!target.closest('.tab-panel') && !target.closest('.tab-btn')) {
      this.closePanels();
    }
  }
}
